module.exports = __webpack_public_path__ + "img/avatar2-icon.9b644bd3.svg";